import { useContext } from 'react';

// project-imports
import { ConfigContext } from 'contexts/ConfigContext';

export default function useConfig() {
  return useContext(ConfigContext);
}
